<script>
import { Component, Vue } from "vue-property-decorator";
import printContent from "./print-content";
import printFooter from "./print-footer";
import printHead from "./print-head";
import gridTable from "./common/grid-table";
import _ from "lodash";

@Component({
  components: {
    printContent,
    printFooter,
    printHead,
    gridTable,
  },
})
export default class M60_Print extends Vue {
  info = {
    baseDataList: [],
  };
  chunkArr = [];
  sizeMapList = []

  handlePrintSixty() {
    // POST_MRP_PO_PRINT_SIXTY
    const printDate = this.$utils.formatTime(new Date());
    this.$apis.autoAPi
      .POST_MRP_PO_PRINT_SIXTY({
        scmPoNumber: this.$route.query.scmPoNumber || "",
      })
      .done((res) => {
        let poItemCategory = ''
        _.each(res.data.poItems, dataItem => {
          poItemCategory = dataItem.poItemCategory
          _.each(dataItem.poScheduleLineSummaries, item => {
            item.sizeDesc = item.sizeDesc ? item.sizeDesc.split('/')[0] : item.sizeCode
            item.description = res.data.description
          })
        })
        const data = res.data;
        let baseDataList = [
          // SUPPLIER 供应商 TODO
          {
            vendorCode: data.vendorCode,
            sapPoNo: data.sapPoNo,
            sourceArea: data.sourceArea,
            fixedText: data.years + '-' + data.periods, // 年季度
            poArea: data.poArea,
          },
          {
            // 固定文字
            style: {
              // background: 'rgba(255,255,128,.5) !important',
            },
            vendorCode: "PAYMENT 支付方式",
            sapPoNo: "DELIVERY TERMS交货方式",
            fixedText: "TRANSPORT MODE 运输方式",
            sourceArea: "DELIVERY PLACE交货地点",
          },
          {
            vendorCode: data.paymentTermDesc,
            sapPoNo: poItemCategory, // 交货方式
            fixedText: data.transportMode,
            sourceArea: data.deliveryPlace,
          },
        ];
        /*let arr = [...Array(6)].map((item, index) => {
          return {
            ...data.poItems[0],
            materialCode: 'test' + index
          }
        })*/
        // 分组条件 当前款号+颜色信息
        
        let groupList = data.poItems.reduce((pre, cur, index) => {
          let key = "";
          let summaryMap = _.groupBy(
            cur.poScheduleLineSummaries,
            (gItem) => gItem.colorCode
          );
          _.forIn(summaryMap, (list, colorCode) => {
            key = cur.materialCode + colorCode + cur.relLogicCode;
            if (!(key in pre)) {
              pre[key] = [
                {
                  ...cur,
                  poScheduleLineSummaries: list,
                },
              ];
            }
          });

          return pre;
        }, {});
        _.each(data.poItems, dataItem => {
          _.each(dataItem.poScheduleLineSummaries, item => {
            if(!this.sizeMapList.includes(item.sizeDesc)) {
              this.sizeMapList.push(item.sizeDesc)
            }
          })
        })
        // chunkArr -> [[],[]]
        this.chunkArr = Object.values(groupList); // Chunk(Object.values(groupList), 3)
        this.info = data;
        this.info.baseDataList = baseDataList;
        this.info.printDate = printDate;

        function Chunk(arr = [], size = 1) {
          return arr.length
            ? arr.reduce(
                (t, v) => (
                  t[t.length - 1].length === size
                    ? t.push([v])
                    : t[t.length - 1].push(v),
                  t
                ),
                [[]]
              )
            : [];
        }
      })
      .fail((err) => {});
  }

  mounted() {
    this.handlePrintSixty();
  }

  render(h) {
    const { chunkArr, info } = this;
    let _this = this
    let otherInfoColumns2 = [
      {
        label: "SAP Code",
        property: "materialCode",
      },
      {
        label: "Style Description",
        property: "materialDescEn",
      },
      {
        label: "Color",
        property: "colorCode",
      },
      {
        label: "Inseam size",
        property: 'inseamSize'
      },
      {
        label: "Order Destination",
        property: 'relLogicCode'
      },
    ];
    
    const currentPageData = function (item) {
      /*
        poScheduleLineSummaries
        allTotalPrice  总合计价
        allTotalQTY 总合计数量*/
      let [poScheduleLineSummaries, allTotalPrice, allTotalQTY] = [[], 0, 0];
      // otherInfo -> [[],[]] 表格2 3 数据
      let sizeMap = {}
      let otherInfo = item.map((inner) => {
        let sizeTotalMap = {}
        const quantitySizeCode = [
        ];
        /*
          totalPrice  合计价
          totalQTY  合计数量
          price 单价
          currency 币种
         */
        let [materialInfo, totalPrice, totalQTY, price, currency] = [
          "",
          0,
          0,
          0,
          "",
        ];
        let otherDataList = []
        let otherDataList2 = []
        _.each(inner, (item) => {
          let innerGroup = _.groupBy(item.poScheduleLineSummaries, 'inseamSize')
          
          // 表头
          _.each(item.poScheduleLineSummaries, _item => {
            if(sizeMap[_item.sizeDesc] == undefined) { // 
              otherInfoColumns2.push({
                label: _item.sizeDesc || "",
                property: _item.sizeDesc || "",
              });
            }
            sizeTotalMap[_item.sizeDesc] = (sizeTotalMap[_item.sizeDesc] || 0) + (_item.quantity || 0)
            sizeMap[_item.sizeDesc] = _item.sizeDesc
            item.colorDesc = _item.colorDesc
            item.currency = _item.currency
            item.price = _item.price
            item.description = _item.description
            item.colorDescEn = _item.colorDescEn
          })
          otherDataList.push(item)
          // size 内容
          _.each(innerGroup, sizeList => {
            let innerItem = {}
            let innerTotal = 0
            _.each(sizeList, sizeItem => {
              innerTotal += sizeItem.quantity
              innerItem[sizeItem.sizeDesc] = sizeItem.quantity
              innerItem.inseamSize = sizeItem.inseamSize
              innerItem.colorCode = sizeItem.colorCode
              innerItem.colorDescEn = sizeItem.colorDescEn
              innerItem.relLogicCode = item.relLogicCode
              innerItem.materialCode = item.materialCode
              innerItem.materialDesc = item.materialDesc
              innerItem.materialDescEn = item.materialDescEn
              totalPrice = innerTotal * sizeItem.price || 0; 
            })
            innerItem.totalQuantity = innerTotal
            totalQTY += innerTotal
            allTotalPrice += totalPrice;
            otherDataList2.push(innerItem)
          })
          allTotalQTY += totalQTY
          console.log('_this.sizeMapList:', _this.sizeMapList)
          _.each(_this.sizeMapList, item => { // 遍历全部尺码
            quantitySizeCode.push({
              quantity: sizeTotalMap[item] || '',
            });
          })
          quantitySizeCode.push({
            quantity: (totalQTY || 0).toFixed(0),
          });
        });
        
        // 定义表格 行
        const renderCell = {
          render: function (h) {
            const gridStyle = {
              display: "grid",
              "grid-template-columns": `repeat(${otherInfoColumns2.length + 1}, 1fr)`,
              'grid-template-rows': 'repeat(1, 30px)',
              gridColumnGap: "0",
              gridRowGap: "0",
              borderTop: "1px solid"
            };
            const commonStyle = {
              "font-size": "12px",
              " word-break": "break-word",
              "text-align": "center",
              'display': 'flex', 
              'justify-content': 'center', 
              'align-items': 'center'
            };
            return (
              <div style={gridStyle}>
                <div
                  style={{
                    gridColumn: `1/6`,
                    borderRight: "1px solid",
                    wordBreak: "break-all",
                    ...commonStyle
                  }}
                >
                  Total 
                </div>
                {quantitySizeCode.map((item, index, sources) => (
                  <div
                    style={{
                      borderRight: "1px solid",
                      ...commonStyle,
                    }}
                  >
                    {item.quantity}
                  </div>
                ))}
              </div>
            );
          },
        };
        // 表格total数据
        let totalColumnsList = [
          {
            label: "FINAL TOTAL",
            property: "FINAL_TOTAL",
          },
          {
            label: (allTotalQTY || 0).toFixed(0),
            property: (allTotalQTY || 0).toFixed(0),
          },
        ];
        let totalDataList = [
          {
            FINAL_TOTAL: "TOTAL Amount",
            [(allTotalQTY || 0).toFixed(0)]: (allTotalPrice || 0).toFixed(2),
          },
        ];
        return {
          otherDataList: otherDataList,
          otherDataList2: [...otherDataList2, renderCell],
          totalColumnsList: totalColumnsList,
          totalDataList: totalDataList,
          otherInfoColumns2,
        };
      });
      return otherInfo;
    };
    return (
      <div style="background: #fff;">
        <div class="print-box">
          <printHead info={info}></printHead>
          <printContent
            otherInfo={currentPageData(chunkArr)}
            info={info}
          ></printContent>
          {
            <printFooter
              info={info}
              // {...{
              //   props: {
              //     currentPage: index + 1,
              //     totalPage: chunkArr.length
              //   }
              // }}
            ></printFooter>
          }
        </div>
      </div>
    );
  }
}
</script>
<style scoped>
/*@page { size: portrait }*/
@media print {
  .print-box {
    page-break-inside: avoid !important;
    page-break-before: unset !important;
    padding: 14px 30px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }
}

.print-box {
  page-break-inside: avoid !important;
  page-break-before: unset !important;
  padding: 14px 30px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  /*padding-bottom: 0;*/
}
</style>
